export default __webpack_public_path__ + "static/media/video2.2aa2ab16.mp4";